import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, X } from "lucide-react";
import { WhatsAppIcon } from "@/components/Icons";
import { BRAND } from "@/data/content";

export const FloatingContact = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[60] flex flex-col items-end gap-3" data-testid="floating-contact">
      <AnimatePresence>
        {open && (
          <>
            <motion.a
              key="wa"
              href={BRAND.whatsapp} target="_blank" rel="noreferrer"
              initial={{ opacity: 0, y: 12, scale: 0.8 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 12, scale: 0.8 }}
              transition={{ duration: 0.2 }}
              className="flex items-center gap-3 rounded-full bg-white shadow-lg border border-zinc-200 pl-4 pr-2 py-2"
              data-testid="floating-whatsapp">
              <span className="text-sm font-semibold text-ink">WhatsApp</span>
              <span className="h-10 w-10 rounded-full bg-forest text-white flex items-center justify-center"><WhatsAppIcon size={20} /></span>
            </motion.a>
            <motion.a
              key="call"
              href={BRAND.phoneHref}
              initial={{ opacity: 0, y: 12, scale: 0.8 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 12, scale: 0.8 }}
              transition={{ duration: 0.2, delay: 0.04 }}
              className="flex items-center gap-3 rounded-full bg-white shadow-lg border border-zinc-200 pl-4 pr-2 py-2"
              data-testid="floating-call">
              <span className="text-sm font-semibold text-ink">Call now</span>
              <span className="h-10 w-10 rounded-full bg-ink text-white flex items-center justify-center"><Phone size={18} /></span>
            </motion.a>
          </>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Contact options"
        data-testid="floating-toggle"
        className="h-14 w-14 rounded-full bg-forest text-white shadow-xl flex items-center justify-center transition-transform hover:-translate-y-1 active:translate-y-0"
      >
        {open ? <X size={24} /> : <WhatsAppIcon size={28} />}
      </button>
    </div>
  );
};

export default FloatingContact;
